module.exports = __webpack_public_path__ + "static/media/digital.0bd60202.png";